<template>
  <v-container>
    <v-form @submit.prevent="createSection">
      <v-text-field type="number" label="Nummer" hint="Nach dieser Nummer werden die Sektionen sortiert." v-model="section.id"/>
      <v-text-field type="text" label="Titel" v-model="section.title"/>
      <v-textarea type="text" label="Beschreibung" v-model="section.description"/>
      <v-select
          :items="locales"
          v-model="section.languageCode"
          :label="$t('settingsPopup.admin.trainingCenter.courseSection.selectLanguage')"
      />
      <v-btn type="submit" block>Sektion erstellen</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import Section from "@/models/section";
import {createSection} from "@/services/courses.service";
import {i18n} from "@/plugins/l18i/i18n";

export default {
  name: "CreateSection",
  data(){
    return{
      locales: i18n.global.availableLocales,
      section:new Section()
    }
  },
  methods:{
    createSection() {
      let self=this;
      createSection(this.section).then((response)=>{
        console.log("Create Section",response);
        self.$router.push("/admin/weiterbildung/section")
      });

    }
  }
}
</script>

<style scoped>

</style>